var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3332 8.6665H23.3465M9.33317 2.6665H22.6665C26.3484 2.6665 29.3332 5.65127 29.3332 9.33317V22.6665C29.3332 26.3484 26.3484 29.3332 22.6665 29.3332H9.33317C5.65127 29.3332 2.6665 26.3484 2.6665 22.6665V9.33317C2.6665 5.65127 5.65127 2.6665 9.33317 2.6665ZM21.3332 15.1598C21.4977 16.2695 21.3082 17.4028 20.7915 18.3985C20.2749 19.3943 19.4574 20.2017 18.4553 20.7061C17.4533 21.2104 16.3178 21.386 15.2102 21.2077C14.1027 21.0295 13.0795 20.5066 12.2863 19.7134C11.4931 18.9202 10.9701 17.897 10.7919 16.7895C10.6137 15.6819 10.7893 14.5464 11.2936 13.5443C11.798 12.5423 12.6054 11.7248 13.6012 11.2082C14.5969 10.6915 15.7302 10.502 16.8398 10.6665C17.9717 10.8344 19.0196 11.3618 19.8288 12.1709C20.6379 12.98 21.1653 14.0279 21.3332 15.1598Z",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramBlack);
export default __webpack_public_path__ + "static/media/instagramBlack.14a92b06cbca2cc8b3f589ebcb8919c2.svg";
export { ForwardRef as ReactComponent };